import { SectionsNavProps } from '@/models/Applications';

import ButtonLink from '../links/ButtonLink';
import NextImage from '../NextImage';

export default function ApplicationsMobile(props: SectionsNavProps) {
  const { sectionnavigation } = props;

  return (
    <nav>
      <ul className='applications__ul flex w-full flex-col items-center justify-center gap-6'>
        {sectionnavigation.map((item, index: number) => {
          if (!item.sectionname) return null;

          return (
            <li
              key={item.targetsectionid}
              className='w-full'
              data-aos='fade-in'
              data-aos-anchor='#applications'
              data-aos-delay={index * 100 + 200}
            >
              <ButtonLink
                href={`#${item.targetsectionid}`}
                variant='outline'
                className='flex items-center gap-x-3 px-3 py-6 text-2xl'
                scrollToAnchor
              >
                <div className='flex h-10 w-10 items-center justify-center'>
                  <NextImage
                    src={`/images/${item.targetsectionid}-sm.svg`}
                    alt={item.sectionname}
                    height='40'
                    width='40'
                    style={{ width: '40px', height: '40px' }}
                  />
                </div>
                <span className='pointer-events-none'>{item.sectionname}</span>
                <NextImage
                  src='/images/arrow-link.svg'
                  alt='Go to section'
                  className='ml-auto'
                  width='24'
                  height='24'
                />
              </ButtonLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
